import SessionsRequest from '../SessionsRequest';
import { Method } from '../../common/Constants';
import Util from '../../analytics/util';
import Log from '../../common/log';
import { SessionsTag } from '../../common/Constants';
/**
 * Handles plugin and player logging for QA tools
 */
export default class PluginLogger {
    constructor(core, options, requestBuilder, queueRequest, isMethodPostEnabled) {
        this.core = core;
        this.options = options;
        this.requestBuilder = requestBuilder;
        this.queueRequest = queueRequest;
        this.isMethodPostEnabled = isMethodPostEnabled;
    }
    /**
     * Check if plugin logs are enabled
     */
    isPluginLogsEnabled() {
        Log.debug(SessionsTag, 'isPluginLogsEnabled: ' + this.options['debug.pluginLogs.enabled']);
        return Util.parseBoolean(this.options['debug.pluginLogs.enabled']);
    }
    /**
     * Check if player logs are enabled
     */
    isPlayerLogsEnabled() {
        Log.debug(SessionsTag, 'isPlayerLogsEnabled: ' + this.options['debug.playerLogs.enabled']);
        return Util.parseBoolean(this.options['debug.playerLogs.enabled']);
    }
    /**
     * Send plugin logs
     * @param willSendLog - Log identifier
     * @param service - Service name
     * @param params - Log parameters
     */
    sendPluginLogs(willSendLog, service, params) {
        if (this.core.isUsingLegacy())
            return;
        if (this.isPluginLogsEnabled()) {
            try {
                if (params && params.logType && params.logAction) {
                    const token = this.core.getFastDataSessionToken();
                    Log.notice(SessionsTag, token.length ? '[' + token + '] ' : '' + params.logType + ': Action ' + params.logAction);
                }
            }
            catch (e) {
                /* empty */
            }
            params['timemark'] = new Date().getTime();
            params = this.requestBuilder.buildParams(params, service);
            if (params !== null && this.options.enabled) {
                const request = new SessionsRequest(service, params);
                if (this.isMethodPostEnabled()) {
                    request.setMethod(Method.POST);
                }
                this.queueRequest(request);
            }
        }
    }
    /**
     * Log session start event
     * @param dimensions - Event dimensions
     */
    logFireSessionStartEvent(dimensions) {
        const params = {
            logs: {
                data: dimensions
            },
            logAction: 'startSession',
            logType: 'pluginMethod'
        };
        this.sendPluginLogs('WILL_SEND_LOG_INFINITY_START', 'app-analytics-plugin-logs', params);
    }
    /**
     * Log session stop event
     * @param eventParams - Event parameters
     */
    logFireSessionStopEvent(eventParams) {
        const params = {
            logs: {
                data: eventParams
            },
            logAction: 'stopSession',
            logType: 'pluginMethod'
        };
        this.sendPluginLogs('WILL_SEND_LOG_INFINITY_START', 'app-analytics-plugin-logs', params);
    }
    /**
     * Log session error event
     */
    logFireSessionErrorEvent(code, msg, errorType = '', metadata = '', duration = 0, dimensions = {}, values = {}) {
        const params = {
            logs: {
                data: {
                    code,
                    msg,
                    errorType,
                    metadata,
                    duration,
                    dimensions,
                    values
                }
            },
            logAction: 'errorSession',
            logType: 'pluginMethod'
        };
        this.sendPluginLogs('WILL_SEND_LOG_INFINITY_START', 'app-analytics-plugin-logs', params);
    }
    /**
     * Log event
     * @param eventName - Event name
     */
    logFireEventListener(eventName) {
        const params = {
            logs: {
                data: eventName
            },
            logAction: 'eventSession',
            logType: 'pluginMethod'
        };
        this.sendPluginLogs('WILL_SEND_LOG_INFINITY_EVENT', 'app-analytics-plugin-logs', params);
    }
    /**
     * Log event end
     * @param eventName - Event name
     */
    logFireEventEndListener(eventName) {
        const params = {
            logs: {
                data: eventName
            },
            logAction: 'eventEndSession',
            logType: 'pluginMethod'
        };
        this.sendPluginLogs('WILL_SEND_LOG_INFINITY_EVENT_END', 'app-analytics-plugin-logs', params);
    }
    /**
     * Log navigation
     * @param dimensions - Navigation dimensions
     */
    logFireNavListener(dimensions) {
        const params = {
            logs: {
                data: dimensions
            },
            logAction: 'nav',
            logType: 'pluginMethod'
        };
        this.sendPluginLogs('WILL_SEND_LOG_INFINITY_NAV', 'app-analytics-plugin-logs', params);
    }
}
